/* Candywrap mandlade v2: aantal, verwijderen, cadeau kiezen en aanvullen. cw-cart-sync.js ververst de lade na elke wijziging. */
(function () {
  'use strict';
  if (window.__cwDrawer) return;
  window.__cwDrawer = true;

  var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busyNow = false;

  function drawer() { return document.getElementById('cart-drawer'); }
  function busy(on) { busyNow = on; var d = drawer(); if (d) d.classList.toggle('cwd-busy', on); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: H, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function done() {
    busy(false);
    try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
  }
  function fail(err) {
    busy(false);
    var m = document.querySelector('[data-cwd-msg]');
    if (m) {
      m.textContent = (err && (err.description || err.message)) || 'Dat lukte niet, probeer het opnieuw.';
      m.hidden = false;
    }
    try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); } catch (e) {}
  }

  function setGift(btn) {
    var key = String(btn.getAttribute('data-key'));
    var vid = parseInt(btn.getAttribute('data-cwd-gift'), 10);
    var root = btn.closest('[data-cwd]');
    var props = { _cw_gift: key };
    props[(root && root.getAttribute('data-gift-label')) || 'Gratis cadeau'] = btn.getAttribute('data-label') || 'Cadeau';
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var old = (cart.items || []).filter(function (it) { return String((it.properties || {})._cw_gift) === key; });
        if (old.length === 1 && old[0].variant_id === vid) return null;
        var u = {};
        old.forEach(function (it) { u[it.key] = 0; });
        var clear = old.length ? post('/cart/update.js', { updates: u }) : Promise.resolve();
        return clear.then(function () { return post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: props }] }); });
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cwd-qty],[data-cwd-rm],[data-cwd-gift],[data-cwd-add]');
    if (!b || !b.closest('#cart-drawer')) return;
    e.preventDefault();
    if (b.disabled || busyNow) return;
    var m = document.querySelector('[data-cwd-msg]'); if (m) m.hidden = true;
    busy(true);
    var job;
    if (b.hasAttribute('data-cwd-qty')) {
      job = post('/cart/change.js', { id: b.getAttribute('data-cwd-qty'), quantity: Math.max(0, parseInt(b.getAttribute('data-q'), 10) || 0) });
    } else if (b.hasAttribute('data-cwd-rm')) {
      var u = {};
      b.getAttribute('data-cwd-rm').split(',').forEach(function (k) { if (k) u[k] = 0; });
      job = post('/cart/update.js', { updates: u });
    } else if (b.hasAttribute('data-cwd-gift')) {
      b.classList.add('is-on');
      job = setGift(b);
    } else {
      job = post('/cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-cwd-add'), 10), quantity: 1 }] });
    }
    job.then(done, fail);
  });
})();

/* klik naast de lade: lade dicht. Pagina erachter gedimd zolang de lade open is. */
(function () {
  if (window.__cwDrawerOutside) return;
  window.__cwDrawerOutside = true;
  document.addEventListener('click', function (e) {
    var d = document.getElementById('cart-drawer');
    if (!d || d.getAttribute('aria-hidden') !== 'false') return;
    var t = e.target;
    if (!t || !t.isConnected || d.contains(t)) return;
    if (t.closest('#cart-icon, .cart-icon, [data-cw-add], quick-add-drawer, .drawer, [role="dialog"], #CybotCookiebotDialog')) return;
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
  });
})();
